import React from 'react';

const PencilIcon = () => {
  return (

    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_684_4371)">
        <path d="M13.7036 2.69524L17.554 6.54561M3.14028 13.2578L6.9944 17.1051M17.8919 2.35774C17.3759 1.84392 16.676 1.55763 15.9478 1.56256C15.2196 1.56749 14.5236 1.86323 14.0146 2.38398L3.13995 13.2586L1.8125 18.4372L6.99107 17.109L17.8657 6.23435C18.3866 5.72557 18.6824 5.02964 18.6874 4.30152C18.6923 3.57339 18.4059 2.87352 17.8919 2.35774Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_684_4371">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  );
};

export default PencilIcon;